import { ReactNode } from 'react'

import { Link } from './Link'

export function ExternalLink({
  children,
  href,
  className = 'underline font-medium text-purple',
  rel,
  unsafe = false,
}: {
  children: ReactNode
  href?: string
  className?: string
  rel?: string
  unsafe?: boolean
}): React.ReactElement {
  if (!href) return <span className={className}>{children}</span>
  return (
    <Link className={className} rel={unsafe ? 'noreferrer' : rel} target="_blank" to={href}>
      {children}
    </Link>
  )
}
